import Navbar from "@/components/Navbar/NavbarView.vue";
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";

export default {
  name: "AdsCenterView",
  components: {
    Navbar,
  },
  data() {
    return ({
      search_query: "",
      is_loading_advertisements: false,
      selected_media_files: [],
      media_previews: [],
      title: "",
      description: "",
      redirection_url: "",
      is_active: true,
      user_details: {},
      advertisements: [],
      modal_advertisement: null,
      active_manage_media_index: 0,
      editing_advertisement_id: null,
      existing_media_delete_ids: [],
    })
  },
  mounted() {
    this.user_details = get_user_details();
    this.get_advertisement();
  },
  computed: {
    filtered_advertisements() {
      const query = this.search_query.trim().toLowerCase();
      if (!query) return this.advertisements;

      return this.advertisements.filter((advertisement) => (
        String(advertisement?.title || "").toLowerCase().includes(query) ||
        String(advertisement?.description || "").toLowerCase().includes(query) ||
        String(advertisement?.id || "").toLowerCase().includes(query)
      ));
    },
    can_save_advertisement() {
      if (this.is_editing_advertisement) {
        return this.media_previews.length > 0 || this.selected_media_files.length > 0;
      }

      return this.selected_media_files.length > 0;
    },
    is_editing_advertisement() {
      return Boolean(this.editing_advertisement_id);
    },
    active_manage_media() {
      const files = this.modal_advertisement?.files || [];
      return Reflect.get(files, this.active_manage_media_index) || null;
    },
  },
  methods: {
    open_create_advertisement_modal() {
      this.reset_advertisement_form();
      if (typeof $ !== "undefined") {
        $("#create_advertisement_modal").modal("show");
      }
    },
    close_create_advertisement_modal() {
      if (typeof $ !== "undefined") {
        $("#create_advertisement_modal").modal("hide");
        return;
      }

      if (typeof window !== "undefined" && window.bootstrap) {
        const modal_element = document.getElementById("create_advertisement_modal");
        const modal_instance = window.bootstrap.Modal.getOrCreateInstance(modal_element);
        modal_instance.hide();
      }
    },
    open_manage_advertisement_modal(advertisement) {
      this.modal_advertisement = advertisement;
      this.active_manage_media_index = 0;

      if (typeof $ !== "undefined") {
        $("#manage_advertisement_modal").modal("show");
      }
    },
    close_manage_advertisement_modal() {
      if (typeof $ !== "undefined") {
        $("#manage_advertisement_modal").modal("hide");
      }

      this.modal_advertisement = null;
      this.active_manage_media_index = 0;
    },
    prev_manage_media() {
      const total = this.modal_advertisement?.files?.length || 0;
      if (!total) return;

      this.active_manage_media_index = (this.active_manage_media_index - 1 + total) % total;
    },
    next_manage_media() {
      const total = this.modal_advertisement?.files?.length || 0;
      if (!total) return;

      this.active_manage_media_index = (this.active_manage_media_index + 1) % total;
    },
    reset_advertisement_form() {
      this.title = "";
      this.description = "";
      this.redirection_url = "";
      this.is_active = true;
      this.editing_advertisement_id = null;
      this.existing_media_delete_ids = [];

      this.media_previews.forEach((preview) => {
        if (preview?.src && !preview?.is_existing) {
          URL.revokeObjectURL(preview.src);
        }
      });

      this.selected_media_files = [];
      this.media_previews = [];
    },
    get_file_name(file_obj) {
      return (
        file_obj?.file?.name ||
        file_obj?.name ||
        file_obj?.file_name ||
        ""
      );
    },
    get_file_url(file_obj) {
      return (
        file_obj?.file?.file_url ||
        file_obj?.file?.url ||
        file_obj?.file_url ||
        file_obj?.url ||
        file_obj?.src ||
        ""
      );
    },
    getMediaType(file_obj) {
      const value = String(this.get_file_name(file_obj) || this.get_file_url(file_obj) || "");
      const extension = value.split("?")[0].split(".").pop()?.toLowerCase();

      const image_extensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg", "avif"];
      const video_extensions = ["mp4", "webm", "ogg", "mov", "avi", "mkv", "m4v"];

      if (image_extensions.includes(extension)) {
        return "image";
      }

      if (video_extensions.includes(extension)) {
        return "video";
      }

      return "unknown";
    },
    handle_media_upload(event) {
      const files = Array.from(event?.target?.files || []).filter((file) => {
        const file_type = String(file.type || "");
        return file_type.startsWith("image/") || file_type.startsWith("video/");
      });

      const new_previews = files.map((file) => ({
        name: file.name,
        type: String(file.type || "").startsWith("image/") ? "image" : "video",
        src: URL.createObjectURL(file),
        is_existing: false,
      }));

      this.selected_media_files.push(...files);
      this.media_previews.push(...new_previews);

      if (this.$refs.ads_media_input) {
        this.$refs.ads_media_input.value = "";
      }
    },
    open_media_picker() {
      this.$refs.ads_media_input?.click();
    },
    remove_media_preview(index) {
      const removed_previews = this.media_previews.splice(index, 1);
      const preview = Reflect.get(removed_previews, 0);
      if (!preview) return;

      if (preview.is_existing && preview.id) {
        this.existing_media_delete_ids.push(preview.id);
      } else if (preview.src) {
        URL.revokeObjectURL(preview.src);
      }

      if (!preview.is_existing) {
        const selected_index = this.media_previews
          .slice(0, index)
          .filter((item) => !item?.is_existing).length;
        this.selected_media_files.splice(selected_index, 1);
      }

      if (this.$refs.ads_media_input) {
        this.$refs.ads_media_input.value = "";
      }
    },
    edit_advertisement(advertisement) {
      if (!advertisement) return;

      this.close_manage_advertisement_modal();
      this.reset_advertisement_form();

      this.editing_advertisement_id = advertisement.id;
      this.title = advertisement?.title || "";
      this.description = advertisement?.description || "";
      this.redirection_url = advertisement?.redirect_url || advertisement?.redirection_url || "";
      this.is_active = Boolean(advertisement?.is_active);
      this.media_previews = Array.isArray(advertisement?.files)
        ? advertisement.files.map((file) => ({
          ...file,
          is_existing: true,
        }))
        : [];

      if (typeof $ !== "undefined") {
        $("#create_advertisement_modal").modal("show");
      }
    },
    confirm_delete_advertisement(advertisement) {
      if (!advertisement?.id) return;

      Swal.fire({
        title: "Delete advertisement?",
        text: "This will permanently remove the advertisement.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (!result.isConfirmed) return;
        this.delete_advertisement(advertisement);
      });
    },
    delete_advertisement(advertisement) {
      const payload = {
        advertisement_id: advertisement.id,
        user_id: this.user_details.user_id || "",
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/delete_advertisement/`,
        method: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            this.advertisements = this.advertisements.filter((item) => item.id !== advertisement.id);
            this.close_manage_advertisement_modal();
            Swal.fire({
              title: "Deleted",
              text: "Advertisement deleted successfully.",
              icon: "success",
              position: "bottom-end",
              showConfirmButton: false,
              timer: 2000,
              toast: true,
            });
            return;
          }

          this.handle_save_advertisement_error(response.message || "Failed to delete advertisement.");
        },
        error: (xhr) => {
          this.handle_save_advertisement_error(
            xhr.responseJSON?.message || "Failed to delete advertisement."
          );
        },
      });
    },
    set_active_manage_media(index) {
      Reflect.set(this, "active_manage_media_index", index);
    },
    get_description_preview(description) {
      const value = String(description || "").trim();
      if (value.length <= 100) return value;
      return `${value.slice(0, 100).trimEnd()}...`;
    },
    get_cta_label(advertisement) {
      const url = String(advertisement?.redirect_url || advertisement?.redirection_url || "").toLowerCase();
      const title = String(advertisement?.title || "").toLowerCase();
      const description = String(advertisement?.description || "").toLowerCase();
      const combined = `${url} ${title} ${description}`;

      if (/(apply|career|job|vacancy|recruit)/.test(combined)) return "Apply now";
      if (/(sign up|register|join|premium|subscribe)/.test(combined)) return "Sign up";
      if (/(shop|buy|order|sale)/.test(combined)) return "Shop now";
      return "Learn more";
    },
    save_advertisement() {
      if (!this.can_save_advertisement && !this.is_editing_advertisement) return;

      const payload = this.build_advertisement_payload();

      if (this.is_editing_advertisement) {
        this.update_advertisement(payload);
      } else {
        this.create_advertisement(payload);
      }
    },
    build_advertisement_payload() {
      const payload = new FormData();

      payload.append("user_id", this.user_details.user_id || "");
      payload.append("title", this.title || "");
      payload.append("description", this.description || "");
      if (this.redirection_url){
        payload.append("redirect_url", this.normalize_url(this.redirection_url));
      }
      payload.append("is_active", this.is_active);

      if (this.is_editing_advertisement) {
        payload.append("advertisement_id", this.editing_advertisement_id);
      }

      this.selected_media_files.forEach((file) => {
        payload.append("files", file);
      });

      this.existing_media_delete_ids.forEach((media_id) => {
        payload.append("files_ids_to_delete", media_id);
      });

      return payload;
    },
    create_advertisement(payload) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/create_advertisement/`,
        method: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
        },
        data: payload,
        processData: false,
        contentType: false,
        success: (response) => {
          this.handle_save_advertisement_success(response, "Advertisement created successfully.");
        },
        error: (xhr) => {
          this.handle_save_advertisement_error(
            xhr.responseJSON?.message || "Failed to create advertisement."
          );
        },
      });
    },
    update_advertisement(payload) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/update_advertisement/`,
        method: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
        },
        data: payload,
        processData: false,
        contentType: false,
        success: (response) => {
          this.handle_save_advertisement_success(response, "Advertisement updated successfully.");
        },
        error: (xhr) => {
          this.handle_save_advertisement_error(
            xhr.responseJSON?.message || "Failed to update advertisement."
          );
        },
      });
    },
    handle_save_advertisement_success(response, success_message) {
      if (response.status !== "success") {
        this.handle_save_advertisement_error(response.message || "Failed to save advertisement.");
        return;
      }

      const saved_advertisement = response?.data;

      if (this.is_editing_advertisement) {
        const advertisement_index = this.advertisements.findIndex(
          (advertisement) => advertisement?.id === saved_advertisement?.id
        );

        if (advertisement_index !== -1) {
          this.advertisements.splice(advertisement_index, 1, saved_advertisement);
        } else {
          this.advertisements.unshift(saved_advertisement);
        }
      } else {
        this.advertisements.unshift(saved_advertisement);
      }

      this.close_create_advertisement_modal();
      this.reset_advertisement_form();
      this.modal_advertisement = null;

      Swal.fire({
        title: "Success",
        text: success_message,
        icon: "success",
        position: "bottom-end",
        showConfirmButton: false,
        timer: 2000,
        toast: true,
      });
    },
    handle_save_advertisement_error(message) {
      Swal.fire({
        title: "Error",
        text: message,
        icon: "error",
        position: "bottom-end",
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });
    },
    get_advertisement() {
      this.is_loading_advertisements = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/get_advertisements_by_user_profile/`,
        method: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          user_id: this.user_details.user_id,
        }),
        success: (response) => {
          this.advertisements =response.data;
          this.is_loading_advertisements = false;
        },
        error: () => {
          this.is_loading_advertisements = false;
          this.handle_save_advertisement_error("Failed to fetch advertisements.");
        },
      });
    },
    toggle_advertisement_is_active(advertisement) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/toggle_advertisement_is_active/`,
        method: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          advertisement_id: advertisement.id,
        }),
        success: (response) => {
          let advertisement_response = this.filtered_advertisements.find((item) => item.id === advertisement.id);
          if(advertisement){
            advertisement_response.is_active = !advertisement_response.is_active;
          }
          Swal.fire({
          title: "Success",
          text: response.message,
          icon: "success",
          position: "bottom-end",
          showConfirmButton: false,
          timer: 2000,
          toast: true,
        });

        },
        error: () => {
          this.is_loading_advertisements = false;
          this.handle_save_advertisement_error("Failed to fetch advertisements.");
        },
      });
    },
    normalize_url(url) {
      const value = String(url || "").trim();
      if (!value) return "";
      if (/^https?:\/\//i.test(value)) return value;
      return `https://${value}`;
    },
  },
};
